<template>
    <div>
        <el-form ref="forms" :model="forms" label-width="100px" :rules="rules" class="forms-lines">
            <el-form-item label="商品分类" prop="name">
                <el-select v-model="forms.sp_fl" placeholder="请选择" size="small" clearable filterable>
                    <el-option v-for="item in fl_options" :key="item.id" :label="item.title" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input size="small" v-model="forms.sp_mc" class="zwitdh"></el-input>
            </el-form-item>
            <el-form-item label="商品属性" prop="name">
                <el-checkbox-group v-model="forms.sp_sx">
                    <el-checkbox :label="1">新品</el-checkbox>
                    <el-checkbox :label="2">热销</el-checkbox>
                    <el-checkbox :label="3">特价</el-checkbox>
                    <el-checkbox :label="4">推荐</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <div class="u-f">
                <el-form-item label="销售价格">
                    <el-input size="small" v-model="forms.sp_ssjg" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="市场价格">
                    <el-input size="small" v-model="forms.sp_scjg" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="成本价格">
                    <el-input size="small" v-model="forms.sp_cbjg" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="重量(克)">
                    <el-input size="small" v-model="forms.sp_zl" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="库存">
                    <el-input size="small" v-model="forms.sp_kc" class="zwitdh"></el-input>
                </el-form-item>
            </div>
            <div class="u-f">
                <el-form-item label="赠送积分">
                    <el-input size="small" v-model="forms.sp_zsjf" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="赠送经验">
                    <el-input size="small" v-model="forms.sp_zsjy" class="zwitdh"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input size="small" v-model="forms.sp_px" class="zwitdh"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="商品品牌" prop="name">
                <el-select v-model="forms.sp_sppp" placeholder="请选择" size="small" clearable filterable>
                    <el-option v-for="item in pp_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="配送方式" prop="name">
                <el-select v-model="forms.sp_psfs" placeholder="请选择" size="small" clearable filterable>
                    <el-option v-for="item in fs_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="描述" prop="name">
                <el-input size="small" type="textarea" :rows="2" v-model="forms.sp_ms" class="zwitdh"></el-input>
            </el-form-item>
            <el-form-item label="商品状态" prop="name">
                <el-radio-group v-model="forms.sp_spzt">
                    <el-radio label="0">上架</el-radio>
                    <el-radio label="1">下架</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">立即提交</el-button>
                <el-button type="primary" size="small">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                fl_options: [],
                pp_options: [],
                fs_options: [{
                    id: 1,
                    name: '快递'
                }, {
                    id: 2,
                    name: '物流'
                }, {
                    id: 3,
                    name: '免运费'
                }, ],
                forms: {
                    sp_fl: '',
                    sp_mc: '',
                    sp_sx: '',
                    sp_ssjg: '',
                    sp_scjg: '',
                    sp_cbjg: '',
                    sp_zl: '',
                    sp_kc: '',
                    sp_zsjf: '',
                    sp_zsjy: '',
                    sp_px: '',
                    sp_sppp: '',
                    sp_psfs: '',
                    sp_ms: '',
                    sp_spzt: '',
                },
                rules: {},
            }
        },
        mounted() {

        },
        methods: {
            submit() {

            },
        }
    }
</script>

<style>

</style>